exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dimension-input[data-v-367a2fe0]{display:-ms-flexbox;display:flex;width:100%}.dimension-input>[data-v-367a2fe0]{-ms-flex:1 1 auto;flex:1 1 auto}.dimension-input.imperial>[data-v-367a2fe0]:first-child{border-right:none}.input-right-border[data-v-367a2fe0]{height:45px;border-right:2px solid #aeaeae}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-367a2fe0","scoped":true,"hasInlineConfig":false}!./~/postcss-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/client/components/DimensionInput.vue
// module id = 529
// module chunks = 1